export default "__VITE_ASSET__6Ls7hzho__"